import { Component, input, output, OutputEmitterRef } from '@angular/core';

import { TableRowComponent } from '../../widget-components/table/table-row.component';
import { AdviceMouseClickEvent } from '../models/models';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgClass, NgOptimizedImage, NgStyle, NgTemplateOutlet, LowerCasePipe, DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-disease-overview-table-row',
    styleUrl: '../table.component.scss',
    template: `
      <div class="flex--row" style="height: 100%">
          <div class="flex flex--row flex__child--4 crop-field-cell">
              <mat-checkbox [checked]="selected()" (change)="onSelectionChange($event.checked)">
                  <div class="flex--column text--left" (click)="onClickAdvice($event)">
                      <span class="crop-field-name">{{ cropFieldName() }}</span>
                      <span class="text--gray">{{ amountOfHectares() | number: '1.2' }} {{ 'hectares' | translate | lowercase }}</span>
                  </div>
              </mat-checkbox>
          </div>
          @for (advice of dailyAdvices(); track advice.date) {
              <div class="flex--row flex__child--3 text--center flex--align-center advice-cell"
                   [ngClass]="getClasses(advice)"
                   [ngStyle]="getAdviceSpecificStyling(advice)">
                  @if (advice.isSprayedToday) {
                    <ng-container [ngTemplateOutlet]="sprayedToday"/>
                  }
                  <div class="flex__child--grow advice-text" [class.text--left]="advice.isSprayedToday"
                       style="max-width: 60%">
                      {{ getAdviceText(advice) | translate }}
                  </div>
              </div>
          }
      </div>
      <ng-template #sprayedToday>
          <div class="legend-icon-container">
              <img class="legend-icon spray"
                   ngSrc="../../../../../../../assets/icons/sprays_or_irrigation.svg"
                   height="24" width="24" alt=""/>
          </div>
      </ng-template>
  `,
    imports: [
        MatCheckbox,
        NgClass,
        NgStyle,
        NgTemplateOutlet,
        LowerCasePipe,
        DecimalPipe,
        NgOptimizedImage,
        TranslatePipe,
    ],
})
export class OverviewTableRowComponent extends TableRowComponent {
  public readonly selected = input<boolean>(false);

  public readonly titleClicked: OutputEmitterRef<AdviceMouseClickEvent> = output<AdviceMouseClickEvent>();

  protected onClickAdvice(mouseEvent: MouseEvent): void {
    this.titleClicked.emit({ mouseEvent, cropField: this.advice() });
  }
}
